import React, { useContext } from 'react';
import { Box, BoxProps } from '@mui/material';
import { UiContext } from 'shared/lib/contexts/uiContext';

export default function PageInnerContainer(props: BoxProps) {
  const {
    spacings: { sp },
  } = useContext(UiContext);

  return (
    <Box
      {...props}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: sp.s80,
        pt: sp.s70,
        flexGrow: 1,
        width: 1,
        ...props.sx,
      }}
    ></Box>
  );
}
